import { useSession } from "../auth";
import { Card, Shell } from "../ui";

/** Shown to anonymous or not-yet-provisioned visitors. */
export function Landing() {
  const session = useSession();

  return (
    <Shell title="Sign in" subtitle="Corporate learning for WithAWill client organisations.">
      <Card>
        {session.status === "unprovisioned" ? (
          <p>
            You are signed in, but this account is not yet set up in the Learning Hub. Open the
            invitation link WithAWill sent you, or contact your programme administrator.
          </p>
        ) : (
          <p>Access is by invitation. Use the link WithAWill emailed you, then sign in below.</p>
        )}
        <p style={{ marginTop: "1rem" }}>
          <a
            href="/.auth/login/withawillciam?post_login_redirect_uri=/"
            style={{
              display: "inline-block",
              padding: "0.5rem 1rem",
              background: "#1a1a2e",
              color: "#fff",
              borderRadius: 8,
              textDecoration: "none",
            }}
          >
            Sign in / Sign up
          </a>
        </p>
        <p style={{ marginTop: "1.5rem", fontSize: "0.8rem", color: "#888" }}>
          WithAWill team member? <a href="/login">Sign in with Microsoft</a>
        </p>
      </Card>
    </Shell>
  );
}
